import { INavigationMenu } from 'components/Layout/Header/Navigation'
import { Link } from 'gatsby'
import React from 'react'

interface Props {
	item: { name: string; href?: string; externalLink?: string; isNew?: boolean }
	colors: INavigationMenu['colors']
}

export default function MenuItem({ item, colors }: Props) {
	return (
		<>
			{item.href ? (
				<Link
					key={item.name}
					to={item.href}
					className={`group -m-3 mb-4 flex items-center rounded-lg px-2 py-3 transition duration-150 ease-in-out last:mb-0 ${colors.hoverBg} hover:no-underline focus:outline-none focus-visible:ring ${colors.focusRing} focus-visible:ring-opacity-50`}
				>
					<div className="ml-4 relative">
						{item.isNew && (
							<div className="absolute top-[2px] -right-10 bg-red-500 text-white rounded px-1 text-xs">
								<span>New</span>
							</div>
						)}
						<p className={`mb-0 text-sm font-medium tracking-wide text-gray-900 group-hover:font-semibold ${colors.groupHoverText}`}>{item.name}</p>
					</div>
				</Link>
			) : (
				<a
					key={item.name}
					href={item.externalLink}
					target="_blank"
					rel="noopener noreferrer"
					className={`group -m-3 mb-4 flex items-center rounded-lg px-2 py-3 transition duration-150 ease-in-out last:mb-0 ${colors.hoverBg} hover:no-underline focus:outline-none focus-visible:ring ${colors.focusRing} focus-visible:ring-opacity-50`}
				>
					<div className="ml-4 relative">
						{item.isNew && (
							<div className="absolute top-[2px] -right-10 bg-red-500 text-white rounded px-1 text-xs">
								<span>New</span>
							</div>
						)}
						<p className={`mb-0 text-sm font-medium tracking-wide text-gray-900 group-hover:font-semibold ${colors.groupHoverText}`}>{item.name}</p>
					</div>
				</a>
			)}
		</>
	)
}
